import { STORAGE_KEYS } from './flowdeskDataModel.js';
import {
  addSyncOperation,
  createSyncOperation,
  markSyncOperationStatus,
  normalizeSyncQueue,
  removeSyncedOperations
} from './syncQueue.js';

export const createFlowDeskRepository = (storage) => ({
  loadAppData: (options) => options.loadFlowDeskData({ storage, ...options }),

  saveLanguage: (value) => storage.save(STORAGE_KEYS.language, value),
  saveTasks: (value) => storage.save(STORAGE_KEYS.tasks, value),
  saveCompanies: (value) => storage.save(STORAGE_KEYS.companies, value),
  saveHealthSettings: (value) => storage.save(STORAGE_KEYS.healthSettings, value),
  saveSoundSettings: (value) => storage.save(STORAGE_KEYS.soundSettings, value),
  saveGovernorate: (value) => storage.save(STORAGE_KEYS.governorate, value),
  saveUiDensity: (value) => storage.save(STORAGE_KEYS.uiDensity, value),
  saveTheme: (value) => storage.save(STORAGE_KEYS.theme, value),
  saveUserName: (value) => storage.save(STORAGE_KEYS.userName, value),
  saveUserPhoto: (value) => storage.save(STORAGE_KEYS.userPhoto, value),
  saveUserRole: (value) => storage.save(STORAGE_KEYS.userRole, value),
  saveCurrentUser: (value) => storage.save(STORAGE_KEYS.currentUser, value),
  saveWorkspaceUsers: (value) => storage.save(STORAGE_KEYS.workspaceUsers, value),
  saveAuthSession: (value) => storage.save(STORAGE_KEYS.authSession, value),
  saveWorkspaceName: (value) => storage.save(STORAGE_KEYS.workspaceName, value),
  saveCurrentWorkspace: (value) => storage.save(STORAGE_KEYS.currentWorkspace, value),
  savePrayerStatus: (value) => storage.save(STORAGE_KEYS.prayerStatus, value),
  saveOnboardingDone: (value) => storage.save(STORAGE_KEYS.onboardingDone, value),
  saveOperationMode: (value) => storage.save(STORAGE_KEYS.operationMode, value),
  saveSyncQueue: (value) => storage.save(STORAGE_KEYS.syncQueue, normalizeSyncQueue(value)),
  saveSyncConnection: (value) => storage.save(STORAGE_KEYS.syncConnection, value),
  saveSyncBackups: (value) => storage.save(STORAGE_KEYS.syncBackups, Array.isArray(value) ? value : []),

  loadSyncQueue: async () => normalizeSyncQueue(await storage.load(STORAGE_KEYS.syncQueue, [])),
  loadSyncBackups: async () => {
    const backups = await storage.load(STORAGE_KEYS.syncBackups, []);
    return Array.isArray(backups) ? backups : [];
  },
  enqueueSyncOperation: async (operationInput) => {
    const queue = normalizeSyncQueue(await storage.load(STORAGE_KEYS.syncQueue, []));
    const operation = createSyncOperation(operationInput);
    const nextQueue = addSyncOperation({ queue, operation });
    await storage.save(STORAGE_KEYS.syncQueue, nextQueue);
    return operation;
  },
  enqueueSyncOperations: async (operationInputs = []) => {
    const queue = normalizeSyncQueue(await storage.load(STORAGE_KEYS.syncQueue, []));
    const operations = operationInputs.filter(Boolean).map(operationInput => createSyncOperation(operationInput));
    const nextQueue = operations.reduce(
      (currentQueue, operation) => addSyncOperation({ queue: currentQueue, operation }),
      queue
    );
    await storage.save(STORAGE_KEYS.syncQueue, nextQueue);
    return operations;
  },
  clearSyncedOperations: async () => {
    const queue = normalizeSyncQueue(await storage.load(STORAGE_KEYS.syncQueue, []));
    const nextQueue = removeSyncedOperations(queue);
    await storage.save(STORAGE_KEYS.syncQueue, nextQueue);
    return nextQueue;
  },
  markSyncOperationStatus: async ({ operationId, status, error = null }) => {
    const queue = normalizeSyncQueue(await storage.load(STORAGE_KEYS.syncQueue, []));
    const nextQueue = markSyncOperationStatus({ queue, operationId, status, error });
    await storage.save(STORAGE_KEYS.syncQueue, nextQueue);
    return nextQueue;
  },

  clearAll: () => storage.clear()
});
